<div fxLayout="column" class="gap-2 m-b-10">
    <div class="vstack">
        <div class="HeaderSet"
             *ngIf="HeaderSet && requestService.selectedRequest.status.dev_name != 'booking_confirmed'"
             matTooltip="These are terms which were agreed at the time of Booking Confirmation, any changes in terms
                will be reflected in the Booking Summary section">
            <span class="editHead editHeadCursor" (click)="leaseDetailsExpand = !leaseDetailsExpand">
                Quotation
                <i class="flaticon-down-chevron" [ngClass]="leaseDetailsExpand? 'more':'' "></i>
            </span>
        </div>
        <div class="reviewBox" [class.viewExpand]="leaseDetailsExpand">
            <div class="quotedate shadoo">
                <label>Booking Date: {{currentDate | date:"dd MMM, yyyy"}}
                    <span
                            *ngIf="requestService.selectedRequest.status.dev_name != 'booking_confirmed' && leaseQuoteService.type != 'confirm'"
                            class="quoteValidTill">(<b> Valid Till</b> : {{
                            (leaseQuoteService.baseQuote?.quote_valid_till| date:"dd MMM,yyyy") ??
                            '-'
                        }})</span>
                </label>
                <div style="display: flex; gap: 5px;">
                    <button
                            [matTooltip]="requestService.selectedRequest.status.dev_name == 'booking_confirmed'? 'Download Smart Contract':'Download Booking Details'"
                            class="editRequest downloadQuoteBtn" mat-icon-button (click)="downloadQuote(commercials)">
                        <i class="flaticon-download"></i>
                    </button>
                    <button [matTooltip]="'Send Smart Contract'" class="editRequest downloadQuoteBtn" mat-icon-button
                            *ngIf="requestService.selectedRequest.status.dev_name == 'booking_confirmed'"
                            (click)="openSendQuoteConfirmationDialog(commercials?.id, 'lease', 'Smart contract shared on email', 'booking')">
                        <i class="flaticon-email"></i>
                    </button>
                </div>
                <!-- <button class="loadingBtn Save" mat-raised-button (click)="saveQuote()"
                    *ngIf="reviewing || leaseQuoteService.type == 'review'">
                    <span>Send Quote</span>
                </button> -->
            </div>

            <div fxLayout="row wrap" class="wholeReview">
                <div fxLayout="column" fxFlex="65" class="leftReview">
                    <div fxLayout="column" class="w-100 shadoo ">
                        <div class="locationBox">
                            <div class="rowSet ">
                                <span fxFlex="30" class="rowSetTitle">ON-HIRE LOCATION</span>
                                <div class="quoteItemsBox locBox">
                                    <div *ngFor="let commercials of commercials.quote_items">
                                        {{commercials.container_size_type?.display}}
                                        :
                                        <ng-container *ngIf="commercials.pol_list!=null">
                                            <span class="location">{{
                                                    commercials.pol_list[0]?.name_display ??
                                                    '-'
                                                }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pol_list?.length > 1">{{commercials.pol_list[1]?.name_display}}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pol_list?.length > 2">{{commercials.pol_list[2]?.name_display}}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pol_list?.length > 3">{{commercials.pol_list[3]?.name_display}}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pol_list?.length > 4">{{commercials.pol_list[4]?.name_display}}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pol_list?.length > 5">{{commercials.pol_list[5]?.name_display}}</span>
                                            <span class="additionalLoc" *ngIf="commercials.pol_list?.length > 6"
                                                  [matTooltipShowDelay]="400"
                                                  [matTooltip]="commercials.pol_list | tooltipList"
                                                  matTooltipClass="tooltip-list">{{
                                                    commercials.pol_list?.length > 6
                                                        ? "+" + (commercials.pol_list?.length - 6) + " more locations"
                                                        : commercials.pol_list?.length == 6
                                                            ? "+" + (commercials.pol_list?.length - 6) + " more locations" : ''
                                                }}
                                            </span>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="rowSet ">
                                <span fxFlex="30" class="rowSetTitle">OFF-HIRE LOCATION</span>
                                <div class=" quoteItemsBox locBox">
                                    <div *ngFor="let commercials of commercials.quote_items">
                                        {{commercials.container_size_type?.display}}
                                        :
                                        <ng-container *ngIf="commercials.pod_list!=null">
                                            <span class="location">{{
                                                    commercials.pod_list[0]?.name_display ??
                                                    '-'
                                                }}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pod_list.length > 1">{{commercials.pod_list[1]?.name_display}}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pod_list.length > 2">{{commercials.pod_list[2]?.name_display}}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pod_list.length > 3">{{commercials.pod_list[3]?.name_display}}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pod_list.length > 4">{{commercials.pod_list[4]?.name_display}}</span>
                                            <span class="location"
                                                  *ngIf="commercials.pod_list.length > 5">{{commercials.pod_list[5]?.name_display}}</span>
                                            <span class="additionalLoc" *ngIf="commercials.pod_list?.length > 6"
                                                  [matTooltipShowDelay]="400"
                                                  [matTooltip]="commercials.pod_list | tooltipList"
                                                  matTooltipClass="tooltip-list">{{
                                                    commercials.pod_list?.length > 6
                                                        ? "+" + (commercials.pod_list?.length - 6) + " more locations" :
                                                        commercials.pod_list?.length == 6
                                                            ? "+" + (commercials.pod_list?.length - 6) + " more locations" : ''
                                                }}
                                            </span>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="commercialTable shadoo">
                        <!-- <span class="title">COMMERCIALS</span> -->
                        <div class="container">
                            <div class="labelSet" fxFlex="30">
                                <span class="titleL">Terms</span>
                                <span class="label">Quantity</span>
                                <span class="label">Condition</span>
                                <span class="label">Leasing Period</span>
                                <span class="label">Per Diem charge</span>
                                <span class="label">Build up Period</span>
                                <span class="label">Build down Period</span>
                                <span class="label">Rate after build down period</span>
                                <span class="label">Minimum Rental Period</span>
                                <span class="label">Early Return Option</span>
                                <span class="label">New Build Price</span>
                                <span class="label">Depreciation Percentage</span>
                                <span class="label">Discounted Residual Value</span>
                                <span class="label">Container Lost After</span>
                                <span class="label">Delivery Schedule Notice Period</span>
                                <span class="label">Return Schedule Amendment</span>
                                <ng-container
                                        *ngIf="leaseQuoteService?.baseQuote?.quote_items[0].ad_hoc_charges?.length > 0">
                                    <ng-container *ngFor="let quote of commercials.quote_items; let i = index">
                                        <ng-container *ngIf="i == 0">
                                            <ng-container *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                                <span class="label">{{
                                                        charge.quote_charge.charge.print_name
                                                    }}</span>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                            <div fxFlex="67" class="valueSetBox">
                                <div class="valueSet" fxFlex="14.7em"
                                     *ngFor="let quote of commercials.quote_items; let i = index">
                                    <span class="valueL">{{quote.container_size_type?.display}}
                                    </span>
                                    <span class="value"> {{quote.quantity ?? '-'}}</span>
                                    <span class="value"> {{
                                            quote.container_condition ? quote.container_condition.value :
                                                '-'
                                        }}</span>
                                    <span class="value"> {{quote.leasing_period_days ?? '-'}}</span>
                                    <span class="value">{{quote.per_diem_charge ?? '-'}}
                                        {{quote.per_diem_charge_currency}}</span>
                                    <span class="value">{{quote.build_up_period_days ?? '-'}}</span>
                                    <span class="value">{{quote.build_down_period_days ?? '-'}}</span>
                                    <span class="value">{{
                                            quote.post_build_down_per_diem_charge ?
                                                quote.post_build_down_per_diem_charge + ' ' +
                                                quote.post_build_down_per_diem_charge_currency : '-'
                                        }}
                                    </span>
                                    <span class="value">{{quote.minimum_rental_period_days ?? '-'}}</span>
                                    <div class="earlyReturnOption">
                                        <span class="value">{{quote.ero.length != 0 ? 'Yes' : 'No'}}</span>
                                        <button class="eroBtn sleekBtn Save"
                                                *ngIf="quote.ero?.length != 0 && quote.is_ero_enabled?.code == true"
                                                mat-raised-button>
                                            View
                                        </button>
                                    </div>
                                    <span class="value">{{
                                            quote.drv_new_build_price ? quote.drv_new_build_price + '' +
                                                quote.drv_new_build_price_currency : '-'
                                        }}
                                    </span>
                                    <span class="value">{{
                                            quote.drv_depreciation_per_year ?
                                                quote.drv_depreciation_per_year + '%' : '-'
                                        }}</span>
                                    <span class="value" *ngIf="quote.drv_max_depreciation_unit == 'price'">
                                        {{
                                            quote.drv_max_depreciation_price ?
                                                quote.drv_max_depreciation_price :
                                                '-'
                                        }}{{quote.drv_max_depreciation_price_currency}}</span>
                                    <span class="value"
                                          *ngIf="quote.drv_max_depreciation_unit == 'percent'">{{
                                            quote.drv_max_depreciation_percent
                                                ?
                                                quote.drv_max_depreciation_percent + '%' : '-'
                                        }}</span>
                                    <span class="value">{{quote.container_deemed_lost_after_days ?? '-'}}</span>
                                    <span class="value">{{
                                            quote.notice_period_amendment_delivery_days ??
                                            '-'
                                        }}</span>
                                    <span class="value">{{quote.notice_period_amendment_return_days ?? '-'}}</span>
                                    <!-- <span class="value"> -->
                                    <ng-container *ngIf="quote?.ad_hoc_charges?.length > 0">
                                        <!-- <div style="display: grid"> -->
                                        <ng-container *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                            <span class="value">{{charge.amount}} {{
                                                    charge.amount_currency
                                                }}</span>
                                        </ng-container>
                                        <!-- </div> -->
                                    </ng-container>
                                    <!-- </span> -->
                                </div>
                            </div>
                        </div>
                        <div class="vstack ">
                            <div class="HeaderSet">
                                <span class="editHead editHeadCursor">
                                    Additional Charges
                                </span>
                            </div>
                            <ng-container>
                                <div class="reviewtable">
                                    <div class="tableRow headerRow">
                                        <div class="headerCell headerSizeTypeAdHoc">Charge Type</div>
                                        <div class="headerCellBoxAdHoc">
                                            <div class="headerCell headerFromDays">Amount</div>
                                        </div>
                                    </div>
                                    <div class="tableRow" style="margin-bottom: 5px;"
                                         *ngFor="let commercial of commercials.ad_hoc_charges">
                                        <div class=" dataCell headerSizeTypeAdHoc"
                                             *ngIf="commercial?.ad_hoc_charges?.length != 0">
                                            {{commercial.quote_charge.charge.print_name}}
                                        </div>
                                        <div class="dataCellBoxAdHoc" *ngIf="commercials.ad_hoc_charges.length != 0">
                                            <div class="dataCellRow">
                                                <div class="dataCell headerFromDays">{{commercial.amount}} {{
                                                        commercial.amount_currency
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <span *ngIf="commercial?.ad_hoc_charges==[]"> No Data Found</span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="vstack ">
                            <div class="HeaderSet">
                                <span class="editHead editHeadCursor">
                                    Early Return Charges
                                </span>
                            </div>
                            <ng-container>
                                <div class="reviewtable">
                                    <div class="tableRow headerRow">
                                        <div class="headerCell headerSizeType">Size Type</div>
                                        <div class="headerCellBox">
                                            <div class="headerCell headerFromDays">From Days</div>
                                            <div class="headerCell headerToDays">To Days</div>
                                            <div class="headerCell headerCharges">Charges</div>
                                            <div class="headerCell headerChargeFrom">Charge From</div>
                                        </div>
                                    </div>
                                    <div class="tableRow" style="margin-bottom: 5px;"
                                         *ngFor="let commercial of commercials.quote_items">
                                        <div class=" dataCell headerSizeType" *ngIf="commercial.ero.length != 0">
                                            {{commercial.container_size_type?.display}}
                                        </div>
                                        <div class="dataCellBox" *ngIf="commercial.ero.length != 0">
                                            <div class="dataCellRow" *ngFor="let ero of commercial.ero">
                                                <div class="dataCell headerFromDays">{{ero.fromDays}}</div>
                                                <div class="dataCell headerToDays">{{ero.toDays}}</div>
                                                <div class="dataCell headerCharges">{{ero.amount}} {{
                                                        ero.amount_currency
                                                    }}
                                                </div>
                                                <div class="dataCell headerChargeFrom"
                                                     *ngIf="ero.penalty_from=='pickup_end_date'">Pick-up End Date
                                                </div>
                                                <div class="dataCell headerChargeFrom"
                                                     *ngIf="ero.penalty_from=='dropoff_end_date'">Drop-off End Date
                                                </div>
                                            </div>
                                        </div>
                                        <span *ngIf="commercial.ero==[]"> No Data Found</span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="vstack " *ngIf="commercials.pickup_schedules.length!=0">
                            <div class="HeaderSet">
                                <span class="editHead editHeadCursor">
                                    Pick-up Schedule
                                </span>
                            </div>
                            <div class="reviewtable">
                                <div class="reviewtable">
                                    <div class="tableRow headerRow">
                                        <div class="headerCell headerSizeType">Size Type</div>
                                        <div class="headerCellBox">
                                            <div class="headerCell headerOnHireLocation">On Hire Location</div>
                                            <div class="headerCell headerPMQ"
                                                 [matTooltip]="'Permitted Monthly Quantity'" matTooltipPosition="left">
                                                PMQ
                                            </div>
                                            <div class="headerCell headerTQP" [matTooltip]="'Total Quantity Permitted'"
                                                 matTooltipPosition="left">TQP
                                            </div>
                                            <div class="headerCell headerHandlingOutCharges">Handling Out Charges</div>
                                            <div class="headerCell headerPickupCharges">Pick-up Charges</div>
                                        </div>
                                    </div>
                                    <div class="tableRow" style="margin-bottom: 5px;"
                                         *ngFor="let pickup of commercials.pickup_schedules">
                                        <div class="dataCell headerSizeType">
                                            {{pickup.requirement.container_size_type?.display}}
                                            ({{pickup.requirement.condition?.description}})
                                        </div>
                                        <div class="dataCellBox">
                                            <div class="dataCellRow">
                                                <div class="dataCell headerOnHireLocation">
                                                    {{pickup?.port?.display_name}}
                                                </div>
                                                <div class="dataCell headerPMQ">{{
                                                        pickup.per_month_permitted_quantity ??
                                                        '-'
                                                    }}
                                                </div>
                                                <div class="dataCell headerTQP">{{
                                                        pickup.total_permitted_quantity ??
                                                        '-'
                                                    }}
                                                </div>
                                                <div class="dataCell headerHandlingOutCharges">{{
                                                        pickup.handling_charge
                                                        ??
                                                        '-'
                                                    }} {{pickup.handling_charge_currency}}
                                                </div>
                                                <div class="dataCell headerPickupCharges">{{
                                                        pickup.pickup_charge ??
                                                        '-'
                                                    }} {{
                                                        pickup.pickup_charge != null ?
                                                            pickup.pickup_charge_currency
                                                            : ''
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vstack " *ngIf="commercials.dropoff_schedules.length!=0">
                            <div class="HeaderSet">
                                <span class="editHead editHeadCursor">
                                    Drop-off Schedule
                                </span>
                            </div>
                            <div class="reviewtable">
                                <div class="tableRow headerRow">
                                    <div class="headerCell headerSizeType">Size Type</div>
                                    <div class="headerCellBox">
                                        <div class="headerCell headerOnHireLocation">On Hire Location</div>
                                        <div class="headerCell headerPMQ" [matTooltip]="'Permitted Monthly Quantity'"
                                             matTooltipPosition="left">
                                            PMQ
                                        </div>
                                        <div class="headerCell headerTQP" [matTooltip]="'Total Quantity Permitted'"
                                             matTooltipPosition="left">TQP
                                        </div>
                                        <div class="headerCell headerHandlingOutCharges">Handling Out Charges</div>
                                        <div class="headerCell headerDrop-offCharges">Drop-off Charges</div>
                                    </div>
                                </div>
                                <div class="tableRow" style="margin-bottom: 5px;"
                                     *ngFor="let dropoff of commercials.dropoff_schedules">
                                    <div class="dataCell headerSizeType">
                                        {{dropoff.requirement.container_size_type?.display}}
                                        ({{dropoff.requirement.condition?.description}})
                                    </div>
                                    <div class="dataCellBox">
                                        <div class="dataCellRow">
                                            <div class="dataCell headerOnHireLocation">
                                                {{dropoff?.port?.display_name}}
                                            </div>
                                            <div class="dataCell headerPMQ">
                                                {{dropoff.per_month_permitted_quantity ?? '-'}}
                                            </div>
                                            <div class="dataCell headerTQP">{{
                                                    dropoff.total_permitted_quantity
                                                    ?? '-'
                                                }}
                                            </div>
                                            <div class="dataCell headerHandlingOutCharges">
                                                {{
                                                    dropoff.handling_charge ??
                                                    '-'
                                                }} {{dropoff.handling_charge_currency}}
                                            </div>
                                            <div class="dataCell headerDrop-offCharges">{{
                                                    dropoff.dropoff_charge
                                                    ?? '-'
                                                }}
                                                {{
                                                    dropoff.dropoff_charge != null ? dropoff.dropoff_charge_currency
                                                        : ''
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vstack"
                             *ngIf="requestService.selectedRequest?.status.default_option_dev_name!='cold_leads'">
                            <div class="HeaderSet">
                                <span class="editHead editHeadCursor">
                                    Comments/Attachments
                                </span>
                            </div>
                            <ng-container>
                                <div>
                                    <mat-tab-group animationDuration="1500ms">
                                        <mat-tab label="Comments">
                                            <logzy-quote-remarks fxLayout="row wrap">
                                            </logzy-quote-remarks>
                                        </mat-tab>
                                        <mat-tab label="Attachments">
                                            <div class="mnrList">
                                                <logzy-request-documents fxFlex="100"></logzy-request-documents>
                                                <!-- <ng-container>
                                                        <app-mat-auto-search [isEditable]="true"
                                                            [label]="'Document Type*'" [class.marginb-4]="!showUpload"
                                                            [(ngModel)]="selectedDocument" [displayField]="'name'"
                                                            [name]="'name'" [defaultChip]="false" [idField]="null"
                                                            [options]="documentTypeList" [setSearchValue]="false"
                                                            fxFlex="17em" fxLayout="column" [clearable]=true
                                                            (change)="showDocumentUpload($event)">
                                                        </app-mat-auto-search>
                                                        <div class="choose" fxFlex="100" fxLayout="column"
                                                            *ngIf="showUpload">
                                                            <app-file-field [isEditable]="true" [fileDropArea]="true"
                                                                [showUploadedList]="true" fxLayout="row"
                                                                class="fileDrop dmgDrop"
                                                                [(ngModel)]="commercials.uploaded_documents"
                                                                [documentTypeDevName]="selectedDocumentType"
                                                                [name]="selectedDocumentType">
                                                            </app-file-field>
                                                        </div>
                                                    </ng-container> -->
                                            </div>
                                            <!-- <mat-table [dataSource]="commercials?.uploaded_documents" class="">
                                                    <ng-container matColumnDef="original_filename">
                                                        <mat-header-cell *matHeaderCellDef> File Name
                                                        </mat-header-cell>
                                                        <mat-cell *matCellDef="let document">
                                                            <a [href]='document?.document_file' target="_blank"
                                                                [download]="document?.original_filename+'.'+document?.extension">
                                                                {{document?.original_filename}}.{{document?.extension}}</a>
                                                        </mat-cell>
                                                    </ng-container>

                                                    <ng-container matColumnDef="document_size">
                                                        <mat-header-cell *matHeaderCellDef>
                                                            Size</mat-header-cell>
                                                        <mat-cell
                                                            *matCellDef="let document">{{readableFileSize(document?.size)}}</mat-cell>
                                                    </ng-container>

                                                    <ng-container matColumnDef="document_type">
                                                        <mat-header-cell *matHeaderCellDef> File
                                                            Type</mat-header-cell>
                                                        <mat-cell
                                                            *matCellDef="let document">{{document?.document_type?.name}}
                                                        </mat-cell>
                                                    </ng-container>

                                                    <ng-container matColumnDef="created_by">
                                                        <mat-header-cell *matHeaderCellDef> Uploaded
                                                            By</mat-header-cell>
                                                        <mat-cell *matCellDef="let document">
                                                            <div class="details" fxLayout="column">
                                                                <span class="fw-medium">
                                                                    {{document?.created_by?.first_name}}
                                                                    {{document?.created_by?.last_name}}
                                                                </span>
                                                                <small>
                                                                    {{ document?.created_at | date:'dd MMM, yyyy' }}
                                                                </small>
                                                            </div>
                                                        </mat-cell>
                                                    </ng-container>
                                                    <mat-header-row
                                                        *matHeaderRowDef="displayedColumns;sticky: true"></mat-header-row>
                                                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                                    <span *ngIf="commercials?.uploaded_documents?.length===0"
                                                        class="noData">No
                                                        Data
                                                        Found.</span>
                                                </mat-table> -->
                                            <!-- </div> -->
                                        </mat-tab>
                                    </mat-tab-group>
                                </div>
                            </ng-container>
                        </div>
                        <div class="vstack ">
                            <div class="HeaderSet">
                                <span class="editHead editHeadCursor">
                                    TERMS AND CONDITIONS
                                </span>
                            </div>
                            <ng-container>
                                <quill-view [content]="commercials.terms_and_condition_text" format="html" theme="snow"
                                            style="max-width: 761px; min-height: 100px; overflow: auto;"></quill-view>
                            </ng-container>
                        </div>
                        <div class="vstack"
                             *ngIf="requestService.selectedRequest.status.dev_name == 'booking_confirmed'">
                            <div class="HeaderSet">
                                <span class="editHead editHeadCursor">
                                    Booking Remarks
                                </span>
                            </div>
                            <ng-container>
                                <quill-view [content]="commercials.remarks" format="html" theme="snow"
                                            style="max-width: 761px; min-height: 100px; overflow: auto;"></quill-view>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="rightReview">
                    <div class="shadoo">
                        <span class="title">REQUEST DETAILS</span>
                        <div class="contentBox">
                            <div class="details">
                                <div><span class="label">Equipment </span>:
                                    <div class="dataWrap">
                                        <span *ngFor="let commercials of commercials.quote_items;let last = last"
                                              class="data">
                                            {{commercials.quantity}}*{{commercials.container_size_type?.display}}
                                                                    ({{commercials.container_condition?.value}}
                                                                    ) {{!last ? ',&nbsp;' : '.'}}
                                        </span>
                                    </div>
                                </div>
                                <div><span class="label">Leasing Period </span>:
                                    <div class="dataWrap">
                                        <span *ngFor="let commercials of commercials.quote_items;let last = last"
                                              class="data">
                                            {{commercials.leasing_period_days}} Days
                                            ({{
                                                commercials.container_size_type?.display + '-' +
                                                commercials.container_condition?.value
                                            }})
                                            {{
                                                !last ? ',&nbsp;' : '.'
                                            }}</span>
                                    </div>
                                </div>
                                <div><span class="label">Request Date</span>:
                                    <div class="dataWrap">
                                        <span class="data">
                                            {{requestService.selectedRequest.request_date | date:"dd MMM,yyyy, h:mm a"}}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="shadoo">
                        <span class="title">AGREEMENT DETAILS</span>
                        <div class="contentBox ">
                            <div class="details">
                                <div><span class="label">Agreement No.</span><span class="data"
                                                                                   [ngStyle]="{'color': commercials?.lease_agreement?.agreement_number == null ? 'red' : ''}">
                                        {{
                                        commercials?.lease_agreement?.agreement_number != null ?
                                            ': ' + commercials?.lease_agreement?.agreement_number : '--'
                                    }}</span>
                                </div>
                                <div><span class="label">Lease Start Date </span> <span class="data"
                                                                                        [ngStyle]="{'color': commercials?.lease_agreement?.agreement_starts_from == null ? 'red' : ''}">
                                        {{
                                        commercials?.lease_agreement?.agreement_starts_from != null ?
                                            ': ' +
                                            (commercials?.lease_agreement?.agreement_starts_from | date: "dd MMM,yyyy")
                                            :
                                            '--'
                                    }}</span>
                                </div>
                                <div><span class="label">Lease End Date </span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.agreement_ends_on == null ? 'red' : ''}">
                                        {{
                                            commercials?.lease_agreement?.agreement_ends_on != null ?
                                                ': ' + (commercials?.lease_agreement?.agreement_ends_on | date:"dd MMM,yyyy") :
                                                '--'
                                        }}</span>
                                </div>
                                <div><span class="label">Lease Agreement Days </span> <span class="data"
                                                                                            [ngStyle]="{'color': leaseAgreementDuration == null ? 'red' : ''}">
                                        {{leaseAgreementDuration != null ? ': ' + leaseAgreementDuration : '--'}}</span>
                                </div>
                                <div><span class="label">Lease Use </span> <span class="data"
                                                                                 [ngStyle]="{'color': commercials?.lease_agreement?.lease_purpose == null ? 'red' : ''}">
                                        {{
                                        commercials?.lease_agreement?.lease_purpose != null ?
                                            ': ' + commercials?.lease_agreement?.lease_purpose?.value : '--'
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shadoo">
                        <span class="title">LESSEE DETAILS</span>
                        <div class="contentBox">
                            <div class="details">
                                <div><span class="label">Company Name </span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lessee_company_name == null ? 'red' : ''}">
                                        {{
                                            commercials?.lease_agreement?.lessee_company_name != null ?
                                                ': ' + commercials?.lease_agreement?.lessee_company_name : '--'
                                        }}</span>
                                </div>
                                <div><span class="label">Contact Person</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lessee_contact_person_name == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lessee_contact_person_name != null ?
                                                ': ' + commercials?.lease_agreement?.lessee_contact_person_name : '--'
                                        }}</span>
                                </div>
                                <div><span class="label">Email ID</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lessee_contact_person_email == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lessee_contact_person_email != null ?
                                                ': ' + commercials?.lease_agreement?.lessee_contact_person_email : '--'
                                        }}
                                    </span>
                                </div>
                                <div><span class="label">Address</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lessee_company_address == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lessee_company_address != null ?
                                                ': ' + commercials?.lease_agreement?.lessee_company_address : '--'
                                        }} </span>
                                </div>
                                <div><span class="label">Phone</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lessee_contact_person_phone == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lessee_contact_person_phone != null ?
                                                ': ' + commercials?.lease_agreement?.lessee_contact_person_phone : '--'
                                        }} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shadoo">
                        <span class="title">LESSOR DETAILS</span>
                        <div class="contentBox">
                            <div class="details">
                                <div><span class="label">Company Name </span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lessor_company_name == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lessor_company_name != null ?
                                                ': ' + commercials?.lease_agreement?.lessor_company_name : '--'
                                        }}</span>
                                </div>
                                <div><span class="label">Contact Person</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lessor_contact_person_name == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lessor_contact_person_name != null ?
                                                ': ' + commercials?.lease_agreement?.lessor_contact_person_name : '--'
                                        }}</span>
                                </div>
                                <div><span class="label">Email ID</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lessor_contact_person_email == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lessor_contact_person_email != null ?
                                                ': ' + commercials?.lease_agreement?.lessor_contact_person_email : '--'
                                        }}
                                    </span>
                                </div>
                                <div><span class="label">Address</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lessor_company_address == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lessor_company_address != null ?
                                                ': ' + commercials?.lease_agreement?.lessor_company_address : '--'
                                        }} </span>
                                </div>
                                <div><span class="label">Phone</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lessor_contact_person_phone == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lessor_contact_person_phone != null ?
                                                ': ' + commercials?.lease_agreement?.lessor_contact_person_phone : '--'
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shadoo">
                        <span class="title">BILLING DETAILS</span>
                        <div class="contentBox">
                            <div class="details"
                                 *ngIf="requestService.selectedRequest.status.dev_name != 'booking_confirmed'">
                                <div>
                                    <span class="label">Lease Type </span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lease_type == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lease_type != null ?
                                                ': ' + commercials?.lease_agreement?.lease_type?.display_name : '--'
                                        }}</span>
                                </div>
                                <div><span class="label">Billing Cycle</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.billing_cycle == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.billing_cycle != null ?
                                                ': ' + commercials?.lease_agreement?.billing_cycle?.display_name : '--'
                                        }}</span>
                                </div>
                                <div><span class="label">Billing Date</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.billing_date == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.billing_date != null ?
                                                ': ' + commercials?.lease_agreement?.billing_date?.display_name : '--'
                                        }}
                                    </span>
                                </div>
                                <div><span class="label">Security Deposit</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.security_deposit == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.security_deposit != null ?
                                                ': ' + commercials?.lease_agreement?.security_deposit + ' ' +
                                                commercials.lease_agreement?.security_deposit_currency : '--'
                                        }}
                                    </span>
                                </div>

                            </div>
                            <div class="details"
                                 *ngIf="requestService.selectedRequest.status.dev_name == 'booking_confirmed'">
                                <div><span class="label">Lease Type </span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.lease_type == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.lease_type != null ?
                                                ': ' + commercials?.lease_agreement?.lease_type : '--'
                                        }}</span>
                                </div>
                                <div><span class="label">Billing Cycle</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.billing_cycle == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.billing_cycle != null ?
                                                ': ' + commercials?.lease_agreement?.billing_cycle : '--'
                                        }}</span>
                                </div>
                                <div><span class="label">Billing Date</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.billing_date == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.billing_date != null ?
                                                ': ' + commercials?.lease_agreement?.billing_date : '--'
                                        }}
                                    </span>
                                </div>
                                <div><span class="label">Security Deposit</span>
                                    <span class="data"
                                          [ngStyle]="{'color': commercials?.lease_agreement?.security_deposit == null ? 'red' : ''}">
                                        {{
                                            commercials.lease_agreement?.security_deposit != null ?
                                                ': ' + commercials?.lease_agreement?.security_deposit + ' ' +
                                                commercials.lease_agreement?.security_deposit_currency : '--'
                                        }}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="shadoo">
                        <span class="title">DRV/CONT</span>
                        <div class="drvContent contentBox ">
                            <div *ngFor="let commercials of commercials.quote_items">
                                <span class="dcTitle">{{commercials.container_size_type?.display}} &nbsp;({{
                                        commercials.container_condition?.value
                                    }})</span>
                                <div class="details">
                                    <div><span class="label">New Build Price</span>
                                        <span class="data"
                                              [ngStyle]="{'color': commercials?.drv_new_build_price == null ? 'red' : ''}">
                                            {{
                                                commercials.drv_new_build_price != null ?
                                                    ': ' + commercials?.drv_new_build_price + ' ' +
                                                    commercials.drv_new_build_price_currency : '--'
                                            }}</span>
                                    </div>
                                    <div><span class="label">Depreciation/Year</span>
                                        <span class="data"
                                              [ngStyle]="{'color': commercials?.drv_depreciation_per_year == null ? 'red' : ''}">
                                            {{
                                                commercials.drv_depreciation_per_year != null ?
                                                    ': ' + commercials?.drv_depreciation_per_year + ' %' : '--'
                                            }}</span>
                                    </div>
                                    <div><span class="label">Discounted Residual Value</span>
                                        <span class="data">
                                            <ng-container *ngIf="commercials.drv_max_depreciation_unit == 'price'">
                                                <ng-container *ngIf="commercials.drv_max_depreciation_price!=null">
                                                    {{commercials.drv_max_depreciation_price}}
                                                    {{commercials.drv_max_depreciation_price_currency}}
                                                </ng-container>
                                                <ng-container
                                                        *ngIf="commercials.drv_max_depreciation_price == null">-</ng-container>
                                            </ng-container>
                                            <ng-container *ngIf="commercials.drv_max_depreciation_unit == 'percent'">
                                                <ng-container *ngIf="commercials.drv_max_depreciation_percent!=null">
                                                    {{commercials.drv_max_depreciation_percent}}%
                                                </ng-container>
                                                <ng-container
                                                        *ngIf="commercials.drv_max_depreciation_percent == null">-</ng-container>
                                            </ng-container>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="actionBox" *ngIf="reviewing">
                    <div fxLayout="row wrap" fxFlex="100">
                        <app-text-field [isEditable]="true" [label]="'Remarks'" [name]="'remarks'" [minlength]="0"
                                        *ngIf="leaseQuoteService.type == 'confirm'" [(ngModel)]="remarks"
                                        [isMultiline]="true"
                                        [maxlength]="2000" fxFlex="50" fxLayout="column">
                        </app-text-field>
                        <div fxLayout="row wrap" fxFlex="100">
                            <!-- <mat-checkbox color="primary">Send automatic reminders <i
                                    class="flaticon-message primaryIconHover"
                                    matTooltip="Let the system remind customer for the quotation"
                                    matTooltipPosition="right"></i>
                            </mat-checkbox> -->

                            <div class="btnb">
                                <button class="Cancel" mat-raised-button (click)="back()">Back</button>
                                <button class="loadingBtn Save" mat-raised-button (click)="saveQuote()"
                                        *ngIf="leaseQuoteService.type == 'review'">
                                    <span>Send Quote</span>
                                </button>
                                <div class="btnbConfirm" *ngIf="leaseQuoteService.type == 'confirm'">
                                    <ng-container
                                            *ngIf="requestService.selectedRequest?.status?.dev_name == 'counter_quote_by_internal_user'
                                        || requestService.selectedRequest?.status?.dev_name == '1st_quote_by_internal_user'
                                        || requestService.selectedRequest?.status?.dev_name == 'negotiation_by_external_user'
                                        || requestService.selectedRequest?.status?.dev_name =='quote_accepted_by_external_user'">
                                        <button class="loadingBtn Save" mat-raised-button [disabled]="disableSaveButton"
                                                (click)="bookingConfirmed()">
                                            <span *ngIf="!disableSaveButton">Confirm Booking</span>
                                            <div *ngIf="disableSaveButton" class="p03"><i
                                                    class="flaticon-loading spin"></i>
                                                <span>Saving Booking Details...</span>
                                            </div>
                                        </button>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="vstack">
        <div class="HeaderSet" *ngIf="HeaderSet">
            <span class="editHead editHeadCursor"
                  (click)="requestService.bookingDetailsExpand = !requestService.bookingDetailsExpand">
                Booking Summary
                <i class="flaticon-down-chevron" [ngClass]="requestService.bookingDetailsExpand? 'more':'' "></i>
            </span>
        </div>
        <div class="reviewBox" [class.viewExpand]="requestService.bookingDetailsExpand">
            <div fxLayout="row wrap" class="wholeReview">
                <div fxLayout="column" fxFlex="100" class="leftReview">
                    <div class="commercialTable shadoo">
                        <div class="reopenBooking">
                            <!-- <span class="title">COMMERCIALS</span> -->
                            <div *ngIf="isRebookingAllowed()" class="rebooking-container">
                                <button mat-raised-button class="addBtn clickIt" (click)="showReopenLogs()">Reopen
                                                                                                            Booking
                                </button>
                                <span class="icon-container"><i class="flaticon-approval-logs" (click)="viewLogs()"></i></span>
                            </div>
                        </div>

                        <div class="container">
                            <div class="labelSet" fxFlex="30">
                                <span class="titleL">Terms</span>
                                <span class="label" [class.valueEditMaxHeight]="editQuantity">Quantity</span>
                                <span class="label" [class.valueEditMaxHeight]="editLocation">ON-HIRE LOCATION</span>
                                <span class="label" [class.valueEditMaxHeight]="editLocation">OFF-HIRE LOCATION</span>
                                <span class="label" [class.valueEditMaxHeight]="editCondition">Condition</span>
                                <span class="label" [class.valueEditMaxHeight]="editSizeType">Size Type</span>
                                <span class="label" [class.valueEditMaxHeight]="editLeasingPeriod">Leasing Period</span>
                                <span class="label" [class.valueEditMaxHeight]="editPerDiemCharge">
                                    Per Diem charge</span>
                                <span class="label">Build up Period</span>
                                <span class="label" [class.valueEditMaxHeight]="editBuildDownPeriod">
                                    Build down Period</span>
                                <span class="label" [class.valueEditMaxHeight]="editBuildDownPerDiemCharge">
                                    Rate after build down period</span>
                                <span class="label" [class.valueEditMaxHeight]="minRentalPeriodDays">
                                    Minimum Rental Period</span>
                            </div>
                            <div fxFlex="67" class="valueSetBox">
                                <div class="valueSet" fxFlex="27.7em"
                                     *ngFor="let quote of bookingDetails?.requirements; let i = index">
                                    <span class="valueL">{{quote.container_size_type?.display ?? '-'}}
                                    </span>
                                    <!-- Quantity -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editQuantity"
                                          fxLayout="row">
                                        <ng-container *ngIf="!quote.editQuantity">
                                            {{quote.quantity ?? '-'}}
                                            <i class="flaticon-pencil" (click)="quote.editQuantity = true; edit = true;
                                            editQuantity=true" matTooltip="Edit Quantity" matTooltipPosition="left"
                                               *ngIf="requestService.selectedRequest.is_booking_closed==false"></i>
                                        </ng-container>
                                        <app-number-field [isEditable]="true" [placeholder]="'Quantity'"
                                                          class="w-100i pb-2" *ngIf="quote.editQuantity"
                                                          [(ngModel)]="quote.quantity" [containerNum]="true"
                                                          [noDecimal]="true"
                                                          [maxlength]="4"
                                                          [minValue]="1"
                                                          [errors]="errorObj[quote.id]?.quantity">
                                            </app-number-field>
                                        <!-- <i class="flaticon-save" (click)="postBookingQuantity(quote)" matTooltip="Save Quantity"></i> -->

                                    </span>

                                    <!-- ON-HIRE LOCATION -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editLocation"
                                          fxLayout="row">
                                        <ng-container *ngIf="!quote.editPOL">
                                            <div fxLayout="row" class=" align-items-center gap-1 "
                                                 *ngIf="quote.pol_list!=null">
                                                <span class="location">{{
                                                        quote.pol_list[0]?.name_display ??
                                                        '-'
                                                    }}</span>
                                                <span class="location"
                                                      *ngIf="quote.pol_list?.length > 1"> |
                                                    {{quote.pol_list[1]?.name_display}}</span>
                                                <span class="additionalLoc" *ngIf="quote.pol_list?.length > 2"
                                                      [matTooltipShowDelay]="400"
                                                      [matTooltip]="quote.pol_list | tooltipList"
                                                      matTooltipClass="tooltip-list">{{
                                                        quote.pol_list?.length > 2
                                                            ? "  +" + (quote.pol_list?.length - 2) + " more locations"
                                                            : quote.pol_list?.length == 2
                                                                ? "  +" + (quote.pol_list?.length - 2) + " more locations"
                                                                : ''
                                                    }}
                                                </span>
                                            </div>
                                            <i class="flaticon-pencil" (click)="quote.editPOL = true; quote.editPOD =
                                            true; edit = true;editLocation=true" matTooltip="Edit Locations"
                                               matTooltipPosition="left"
                                               *ngIf="requestService.selectedRequest.is_booking_closed==false"></i>
                                        </ng-container>
                                        <app-mat-auto-search [(ngModel)]="quote.pol_list" *ngIf="quote.editPOL"
                                                             [isEditable]="true"
                                                             [idField]="null" displayField='name_display'
                                                             [trim]="true"
                                                             [multiple]="true"
                                                             [defaultChip]="false" [clearable]="true"
                                                             [closeOnSelect]="false"
                                                             [clearSearchOnAdd]="true"
                                                             [listUrl]="location_url" name="pods" fxLayout="column"
                                                             class="w-100i pb-2 locations"
                                                             [errors]="errorObj[quote.id]?.pol_list">

                                        </app-mat-auto-search>
                                    </span>

                                    <!-- OFF-HIRE LOCATION -->
                                    <span class="value gap-1 justify-content-between"
                                          [class.valueEditMaxHeight]="editLocation" fxLayout="row">
                                        <ng-container *ngIf="!quote.editPOD">
                                            <div fxLayout="row" class=" gap-1 align-items-center "
                                                 *ngIf="quote.pod_list!=null">
                                                <span class="location">{{
                                                        quote.pod_list[0]?.name_display ??
                                                        '-'
                                                    }}</span>
                                                <span class="location"
                                                      *ngIf="quote.pod_list.length > 1"> | {{
                                                        quote.pod_list[1]?.name_display
                                                    }}</span>
                                                <span class="additionalLoc" *ngIf="quote.pod_list?.length > 2"
                                                      [matTooltipShowDelay]="400"
                                                      [matTooltip]="quote.pod_list | tooltipList"
                                                      matTooltipClass="tooltip-list">{{
                                                        quote.pod_list?.length > 2
                                                            ? "  +" + (quote.pod_list?.length - 2) + " more locations" :
                                                            quote.pod_list?.length == 2
                                                                ? "  +" + (quote.pod_list?.length - 2) + " more locations"
                                                                : ''
                                                    }}
                                                </span>
                                            </div>
                                            <!--                                            <i class="flaticon-pencil" (click)="quote.editPOD = true"></i>-->
                                        </ng-container>

                                            <app-mat-auto-search [(ngModel)]="quote.pod_list" *ngIf="quote.editPOD"
                                                                 [isEditable]="true"
                                                                 [idField]="null" displayField='name_display'
                                                                 [trim]="true"
                                                                 [multiple]="true"
                                                                 [defaultChip]="false" [clearable]="true"
                                                                 [closeOnSelect]="false"
                                                                 [clearSearchOnAdd]="true"
                                                                 [listUrl]="location_url" name="pods" fxLayout="column"
                                                                 class="w-100i pb-2 locations"
                                                                 [errors]="errorObj[quote.id]?.pod_list">
                                            </app-mat-auto-search>

                                    </span>

                                    <!-- Condition -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editCondition" fxLayout="row">
                                        <ng-container *ngIf="!quote.editCondition">
                                            {{quote.condition ? quote.condition.value : '-'}}
                                            <!-- <i class="flaticon-pencil" (click)="quote.editCondition = true; edit =
                                            true; editCondition=true"
                                               matTooltip="Edit Condition" *ngIf="requestService.selectedRequest.is_booking_closed==false"></i> -->
                                        </ng-container>
                                        <!-- <ng-container *ngIf="quote.editCondition">
                                            <app-mat-auto-search [isEditable]="true" [displayField]="'value'"
                                                                 [name]="'container_condition'"
                                                                 [(ngModel)]="quote.condition"
                                                                 [idField]="null"
                                                                 [listUrl]="containerConditionLists"
                                                                 [setSearchValue]="false" class="w-100i conditions"
                                                                 [errors]="errorObj.condition">
                                            </app-mat-auto-search>
                                        </ng-container> -->
                                    </span>

                                    <!-- Size Type -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editSizeType" fxLayout="row">
                                        <ng-container *ngIf="!quote.editContainerSizeType">
                                            {{quote.container_size_type?.display ?? '-'}}
                                            <i class="flaticon-pencil" matTooltipPosition="left"
                                               (click)="quote.editContainerSizeType = true; edit = true; editSizeType =true"
                                               matTooltip="Edit Size Type"
                                               *ngIf="requestService.selectedRequest.is_booking_closed==false"></i>
                                        </ng-container>
                                            <app-mat-auto-search [isEditable]="true" fxFlex="100"
                                                                 class="containerType pb-2 conditions "
                                                                 [searchIcon]="true" *ngIf="quote.editContainerSizeType"
                                                                 [(ngModel)]="quote.container_size_type"
                                                                 [idField]="null" displayField='display'
                                                                 [trim]="true"
                                                                 [clearable]="true"
                                                                 [listUrl]="containerSizeTypeUrl"
                                                                 [errors]="errorObj[quote.id]?.container_size_type">
                                            </app-mat-auto-search>
                                    </span>
                                    <!-- <span class="value"> {{quote.leasing_period_days ?? '-'}}</span> -->

                                    <!-- Leasing Period -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editLeasingPeriod" fxLayout="row">
                                        <ng-container *ngIf="!quote.editLeasingPeriod">
                                            {{quote.leasing_period_days ?? '-'}}
                                            <i class="flaticon-pencil" (click)="quote.editLeasingPeriod = true; edit = true;
                                                                          editLeasingPeriod=true"
                                               matTooltip="Edit Leasing Period" matTooltipPosition="left"
                                               *ngIf="requestService.selectedRequest.is_booking_closed==false"></i>
                                        </ng-container>
                                        <ng-container *ngIf="quote.editLeasingPeriod">
                                            <app-number-field [isEditable]="true" [placeholder]="'Leasing Period'"
                                                              class="w-100i pb-2"
                                                              [(ngModel)]="quote.leasing_period_days" [noDecimal]="true"
                                                              [maxlength]="4"
                                                              [minValue]="1"
                                                              [errors]="errorObj[quote.id]?.leasing_period_days">
                                            </app-number-field>
                                            <!-- <i class="flaticon-save" (click)="postLeasingPeriodAndPerDiem(quote)" matTooltip="Save Leasing Period"></i> -->
                                        </ng-container>
                                    </span>
                                    <!-- <span class="value">{{quote.min_per_diem ?? '-'}}
                                        {{quote.min_per_diem_currency}}</span> -->

                                    <!-- Per Diem charge -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editPerDiemCharge" fxLayout="row">
                                            <ng-container *ngIf="!quote.editPerDiemCharge">
                                                {{quote.per_diem}}
                                                {{quote.per_diem_currency}}
                                                <i class="flaticon-pencil" (click)="quote.editPerDiemCharge = true; edit = true;
                                                editPerDiemCharge=true" matTooltipPosition="left"
                                                   matTooltip="Edit Per Diem Charge"></i>
                                            </ng-container>
                                            <ng-container *ngIf="quote.editPerDiemCharge">
                                                <logzy-money-field [isEditable]="true" [placeholder]="'Per Diem Charge'"
                                                                   class="w-100i pb-2" [(amount)]="quote.per_diem"
                                                                   [minValue]="0"
                                                                   [(currencyCode)]="quote.per_diem_currency"
                                                                   [errors]="errorObj.min_per_diem">
                                                </logzy-money-field>
                                                <!-- <i class="flaticon-save" (click)="postLeasingPeriodAndPerDiem(quote)"
                                                    matTooltip="Save Data"></i> -->
                                            </ng-container>
                                        </span>

                                    <!-- Build up Period -->
                                    <span class="value">{{quote.build_up_period_days ?? '-'}}</span>
                                    <!-- <span class="value">{{quote.build_down_period_days ?? '-'}}</span> -->

                                    <!-- Build down Period -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editBuildDownPeriod" fxLayout="row">
                                        <ng-container *ngIf="!quote.editBuildDownPeriod">
                                            {{quote.build_down_period_days ?? '-'}}
                                            <i class="flaticon-pencil" (click)="quote.editBuildDownPeriod = true; edit = true;
                                                                         editBuildDownPeriod=true"
                                               matTooltip="Edit Build Down Period Days" matTooltipPosition="left"
                                               *ngIf="requestService.selectedRequest.is_booking_closed==false"></i>
                                        </ng-container>
                                        <ng-container *ngIf="quote.editBuildDownPeriod">
                                            <app-number-field [isEditable]="true"
                                                              [placeholder]="'Build Down Period Days'"
                                                              class="w-100i pb-2"
                                                              [(ngModel)]="quote.build_down_period_days"
                                                              [noDecimal]="true" [maxlength]="4"
                                                              [minValue]="1"
                                                              [errors]="errorObj[quote.id]?.build_down_period_days">
                                            </app-number-field>
                                            <!-- <i class="flaticon-save" (click)="postBuildDownPeriodAndCharges(quote)" matTooltip="Save Build Down Period Days"></i> -->
                                        </ng-container>
                                    </span>
                                    <!-- <span class="value">{{
                                            quote.post_build_down_per_diem_charge ?
                                                quote.post_build_down_per_diem_charge + ' ' +
                                                quote.post_build_down_per_diem_charge_currency : '-'
                                        }}
                                    </span> -->

                                    <!-- Rate after build down period -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="editBuildDownPerDiemCharge" fxLayout="row">
                                        <ng-container *ngIf="!quote.editBuildDownPerDiemCharge">
                                            {{quote.post_build_down_per_diem_charge}}
                                            {{quote.post_build_down_per_diem_charge_currency}}
                                            <i class="flaticon-pencil" (click)="quote.editBuildDownPerDiemCharge =
                                            true; edit = true;  editBuildDownPerDiemCharge=true"
                                               matTooltipPosition="left"
                                               matTooltip="Edit Build Down Per Diem Charge"></i>
                                        </ng-container>
                                        <ng-container *ngIf="quote.editBuildDownPerDiemCharge">
                                            <logzy-money-field [isEditable]="true"
                                                               [placeholder]="'Buyild Down Per Diem Charge'"
                                                               class="w-100i pb-2"
                                                               [(amount)]="quote.post_build_down_per_diem_charge"
                                                               [minValue]="0"
                                                               [(currencyCode)]="quote.post_build_down_per_diem_charge_currency"
                                                               [errors]="errorObj.post_build_down_per_diem_charge">
                                            </logzy-money-field>
                                            <!-- <i class="flaticon-save" (click)="postBuildDownPeriodAndCharges(quote)"
                                                matTooltip="Save Data"></i> -->
                                        </ng-container>
                                    </span>
                                    <!-- <span class="value">{{quote.minimum_rental_period_days ?? '-'}}</span> -->

                                    <!-- Minimum Rental Period -->
                                    <span class="value justify-content-between"
                                          [class.valueEditMaxHeight]="minRentalPeriodDays" fxLayout="row">
                                        <ng-container *ngIf="!quote.minRentalPeriodDays">
                                            {{quote.minimum_rental_period_days ?? '-'}}
                                            <i class="flaticon-pencil" (click)="quote.minRentalPeriodDays = true; edit = true;
                                                                          minRentalPeriodDays=true"
                                               matTooltip="Edit Minimum Rental Period Days" matTooltipPosition="left"
                                               *ngIf="requestService.selectedRequest.is_booking_closed==false"></i>
                                        </ng-container>
                                        <ng-container *ngIf="quote.minRentalPeriodDays">
                                            <app-number-field [isEditable]="true"
                                                              [placeholder]="'Minimum Rental Period Days'"
                                                              class="w-100i pb-2"
                                                              [(ngModel)]="quote.minimum_rental_period_days"
                                                              [containerNum]="true" [noDecimal]="true" [maxlength]="4"
                                                              [minValue]="1"
                                                              [errors]="errorObj[quote.id]?.minimum_rental_period_days">
                                            </app-number-field>
                                            <!-- <i class="flaticon-save" (click)="postLeasingPeriodAndPerDiem(quote)" matTooltip="Save Leasing Period"></i> -->
                                        </ng-container>
                                    </span>

                                    <!-- button to save after edit -->
                                    <div class="btnb" *ngIf="quote.editQuantity || quote.editPOL || quote.editPOD ||
                                    quote.editCondition || quote.editContainerSizeType  || quote.editLeasingPeriod|| quote.editPerDiemCharge 
                                    || quote.editBuildDownPeriod || quote.editBuildDownPerDiemCharge || quote.minRentalPeriodDays"
                                         style="display: flex;
                                        justify-content: end;
                                        margin-top: 10px;
                                        gap: 10px;">
                                        <button mat-raised-button (click)="saveRequirement(quote)"
                                                class="addBtn clickIt">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btnb" *ngIf="edit"
                             style="display: flex;
                                        justify-content: end;
                                        margin-top: 10px;
                                        gap: 10px;">
                            <button mat-raised-button (click)="reset()" class="Cancel">
                                Cancel
                            </button>
                        </div>
                    </div>
                    <div fxLayout="column" class="w-100 shadoo ">
                        <span class="title">BOOKING CHARGES</span>
                        <logzy-booking-charges (reqContainers)="showContainers($event)"
                                               (addInvoiceParty)="invoiceParty($event)"></logzy-booking-charges>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #ralItemTemplate let-item>
    <div class="ral-container">
        <div class="color-box" [style.background-color]="item?.HEX"></div>
        <div class="color">
            <span class="ral-code">{{item?.RAL ?? '-'}}</span>
            <span class="color-name">{{item?.name ?? '-'}}</span>
        </div>
    </div>
</ng-template>

<ng-template #ralLabelItemTemplate let-item>
    {{item?.name ?? '-'}}
</ng-template>
